import { IPlan, ITask, TTempoData } from "../../../../../common/types";


export default (plan: IPlan, task: ITask) => {
    let tempo = (task.data as TTempoData).tempo;
    if (!tempo) {
        if (task.ref) {
            tempo = plan.scores!.find(s => s._id === task.ref)!.tempo || 60;
        } else {
            tempo = 60;
        }
    }
    return tempo;
};
